export default __webpack_public_path__ + "static/media/customize.70af8472.svg";